import {NgModule} from '@angular/core';
import {ExgCheckboxComponent} from './input/exg-checkbox/exg-checkbox.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {ExgModalComponent} from './modal/exg-modal/exg-modal.component';
import {ExgModalSimpleComponent} from './modal/exg-modal-simple/exg-modal-simple.component';
import {ExgWidgetComponent} from './widget/exg-widget.component';
import {ExgSwitchComponent} from './input/exg-switch/exg-switch.component';
import {ExgInputComponent} from './input/exg-input/exg-input.component';
import {ExgSelectComponent} from './input/exg-select/exg-select.component';
import {ExgOptionComponent} from './input/exg-option/exg-option.component';
import {ExgOptComponent} from './input/exg-opt/exg-opt.component';
import {ExgPopupComponent} from './modal/exg-popup/exg-popup.component';
import {ExgDataTableComponent} from './data/exg-data-table/exg-data-table.component';
import {ExgPagerComponent} from './data/exg-pager/exg-pager.component';
import {ExgSearchBarComponent} from './input/exg-search-bar/exg-search-bar.component';
import {ExgDataListComponent} from './data/exg-data-list/exg-data-list.component';
import {ExgTextareaComponent} from './input/exg-textarea/exg-textarea.component';
import {ExgTabComponent} from './container/exg-tab/exg-tab.component';
import {ExgLaneComponent} from './container/exg-lane/exg-lane.component';
import {ExgKpiCircleComponent} from './kpi/exg-kpi-circle/exg-kpi-circle.component';
import {ExgKpiGaugeComponent} from './kpi/exg-kpi-gauge/exg-kpi-gauge.component';
import {ExgKpiProgressbarComponent} from './kpi/exg-kpi-progressbar/exg-kpi-progressbar.component';
import {ExgChipsComponent} from './data/exg-chips/exg-chips.component';
import {ExgOverlayComponent} from './modal/exg-overlay/exg-overlay.component';
import {ExgPanelComponent} from './container/exg-panel/exg-panel.component';
import {ExgSectionpanelComponent} from './container/exg-sectionpanel/exg-sectionpanel.component';
import {ExgTableComponent} from './data/exg-table/exg-table.component';
import {ExcRestModule} from 'exc-rest-v2';
import {ExgAdaptiveHeightDirective} from './modal/exg-adaptive-height.directive';
import {ExgPreventDefaultDirective} from './modal/exg-prevent-default.directive';
import {ExgTableSettingsComponent} from './data/exg-table/exg-table-settings.component';
import {DragDropModule} from '@angular/cdk/drag-drop';


@NgModule({
  declarations: [ExgCheckboxComponent, ExgModalComponent, ExgModalSimpleComponent, ExgWidgetComponent, ExgWidgetComponent,
    ExgSwitchComponent, ExgSwitchComponent, ExgInputComponent, ExgSelectComponent, ExgOptionComponent, ExgOptComponent,
    ExgPopupComponent, ExgDataTableComponent, ExgPagerComponent, ExgSearchBarComponent, ExgDataListComponent,
    ExgTextareaComponent, ExgTabComponent, ExgLaneComponent, ExgKpiCircleComponent, ExgKpiGaugeComponent,
    ExgKpiProgressbarComponent, ExgChipsComponent, ExgOverlayComponent, ExgPanelComponent, ExgSectionpanelComponent, ExgTableComponent,
    ExgAdaptiveHeightDirective, ExgPreventDefaultDirective, ExgTableSettingsComponent
  ],
  imports: [CommonModule, FormsModule, ExcRestModule, DragDropModule],
  exports: [ExgCheckboxComponent, ExgModalComponent, ExgModalSimpleComponent, ExgWidgetComponent, ExgSwitchComponent,
    ExgSelectComponent, ExgOptionComponent, ExgOptComponent, ExgInputComponent, ExgPopupComponent, ExgDataTableComponent,
    ExgPagerComponent, ExgSearchBarComponent, ExgDataListComponent, ExgTextareaComponent, ExgTabComponent, ExgLaneComponent,
    ExgKpiCircleComponent, ExgKpiGaugeComponent, ExgKpiProgressbarComponent, ExgChipsComponent, ExgOverlayComponent,
    ExgPanelComponent, ExgSectionpanelComponent, ExgTableComponent, ExgAdaptiveHeightDirective, ExgPreventDefaultDirective, ExgTableSettingsComponent
  ]
})
export class ExcControlsModule {
}
